import React from 'react'
import PropTypes from 'prop-types'
import NoIndex from '../NoIndex'
import { markup } from '../../../utils/markup'

import styles from './description.module.scss'
import CollapsedText from '../CollapsedText'

export default function ProductDescription({
  itemDescription,
  title,
  seo,
  collapsed = false,
}) {
  return itemDescription || seo.regularText ? (
    <NoIndex>
      <div className={styles.root}>
        <h2 className={styles.title}>{title}</h2>
        {collapsed ? (
          <div className={styles.text}>
            <CollapsedText
              html={seo.regularText || itemDescription || ''}
              maxCount={200}
            />
          </div>
        ) : (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={markup(
              seo.regularText || itemDescription || ''
            )}
          />
        )}
      </div>
    </NoIndex>
  ) : null
}

ProductDescription.propTypes = {
  content: PropTypes.shape({
    description: PropTypes.string,
  }),
}
